import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/31c6de20-3f8f-4a80-813f-bd17bd6fabeb";
export const REGISTER_URL = "https://a.ntrk2.com/6ad2ca9b-9bec-4611-ad17-ca9d5a2a313e";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://mxwow.loadprkw2a.com/download?openExternalBrowser=1&id=12wjibvb7z1vli2";

export * from "./codes";
export * from "./context";
